import React from "react";

function PrimaryButton({
  children,
  onClick,
  style = {}
}) {
  return (
    <button
      onClick={onClick}
      style={{
        background: "#21b573",
        color: "#fff",
        border: "none",
        padding: "14px 30px",
        borderRadius: "999px",
        fontWeight: 600,
        cursor: "pointer",
        transition: "0.3s",
        ...style
      }}
    >
      {children}
    </button>
  );
}

export default PrimaryButton;